import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { HttpClient } from "@angular/common/http";
import { IStatus, STATUS_TYPE } from "../../@core/models/model";

@Injectable({ providedIn: 'root' })
export class StatusService extends BaseService {
    private statusUrl = environment.apiUrl + '/status';

    constructor(protected override http: HttpClient) {
        super(http);
    }

    getStandardStatuses(data: { statusType: STATUS_TYPE }) {
        return this.post<IStatus[]>(this.statusUrl + '/standard', data);
    }

    getStatuses(statusType: STATUS_TYPE, documentType?: string, projectId?: string, documentId?: string) {
        return this.post<IStatus[]>(this.statusUrl + '/all', { statusType, documentType, projectId, documentId });
    }

    addStatus(name: string, statusType: STATUS_TYPE, documentType?: string) {
        return this.post<IStatus>(this.statusUrl + '/add', { name, statusType, documentType });
    }

    updateStatus(name: string, id: string, statusType: STATUS_TYPE, documentType?: string) {
        return this.put<IStatus>(this.statusUrl + '/update', { name, id, statusType, documentType });
    }

    deleteStatus(statusId: string) {
        return this.delete(this.statusUrl + '/' + statusId);
    }


}